import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { theme } from '../Theme'
import { Link } from 'react-router-dom'
import { Above, Below } from '@jetshop/ui/Breakpoints'
import CategoryTag from './CategoryTag'
import SiteButton from '../Core/SiteButton'
import { NavArrowLeft } from 'iconoir-react'
import { useIntl } from '@jetshop/intl'
import { BRAND_PAGE_ID } from '../Core/Util/Constants'
import { removeAlternativeString } from '../Core/Util/Helpers'

const CategoryTagsWrapper = styled.div`
   font-family: var(--font-industry);
   font-weight: 700;

   .category-tags-inner-wrapper {
      position: relative;
   }

   .category-tags-container {
      display: flex;
      align-items: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      gap: 0.5rem;
      margin-bottom: 1rem;

      ${theme.below.lg} {
         flex-wrap: nowrap;
         overflow: auto;
         gap: 8px;
         justify-content: flex-start;
      }

      a {
         white-space: nowrap;
         margin-bottom: 0.5rem;
      }

      button {
         white-space: nowrap;
      }
   }

   .category-tags-container::-webkit-scrollbar {
      width: 0px;
      background: transparent;
   }

   .hide-fade.category-tags-container::after {
      opacity: 0;
      transition: opacity 0.8s ease-in-out;
   }

   .category-tags-container::after {
      ${theme.below.lg} {
         pointer-events: none; /* ignore clicks */
         content: '';
         position: absolute;
         height: 100%;
         left: 0;
         width: 100%;
         background: -moz-linear-gradient(
            90deg,
            rgba(228, 228, 228, 0) 0%,
            rgba(228, 228, 228, 0) 80%,
            rgb(228, 228, 228, 1) 100%
         );
         background: -webkit-linear-gradient(
            90deg,
            rgba(228, 228, 228, 0) 0%,
            rgba(228, 228, 228, 0) 80%,
            rgb(228, 228, 228, 1) 100%
         );
         background: linear-gradient(
            90deg,
            rgba(228, 228, 228, 0) 0%,
            rgba(228, 228, 228, 0) 80%,
            rgb(228, 228, 228, 1) 100%
         );
         filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#ffffff",GradientType=1);
      }
   }

   .page-hero-category-title {
      font-size: 1.1rem;
      font-weight: 600;
   }

   .override-button {
      font-size: 16px;
   }

   .override-button:hover svg {
      transform: translate(-0.25rem, 0);
      transition: transform 0.5s ease-in-out;
   }
`

const GenerateSiblingsCategories = category => {
   let selectedSibilingCategory = category?.parent?.subcategories.find(
      cat => cat?.id == category?.id
   )
   if (!selectedSibilingCategory) {
      return []
   }
   let sortedCategories =
      category?.parent?.subcategories
         ?.slice()
         ?.sort((a, b) => a.name.localeCompare(b.name))
         ?.filter(cat => cat?.id != category?.id) ?? []

   return [...sortedCategories]
}

export const CategoryTags = ({ category }) => {
   const t = useIntl()
   const [fade, setFade] = useState(false)

   const sortedSubCategories =
      category?.subcategories
         ?.slice()
         ?.sort((a, b) => a.name.localeCompare(b.name)) ?? []

   const hasSubCategories = category?.subcategories?.length > 0

   const sortedSiblingsCategories = GenerateSiblingsCategories(category)

   const handleScroll = e => {
      const rightEnd =
         e.target.scrollWidth - (e.target.scrollLeft + 250) <
         e.target.clientWidth
      if (rightEnd) {
         setFade(true)
         return
      }
      setFade(false)
   }   

   return (
      <>
         {category?.id != BRAND_PAGE_ID &&
            (sortedSubCategories.length > 0 ||
               sortedSiblingsCategories.length > 0) && (
               <CategoryTagsWrapper>
                  {category?.parent && (
                     <SiteButton
                        className="py-8 pr-32 pl-16 override-button d-none d-md-block"
                        size="small"
                        icon={true}
                        styleType="solid"
                        color={'grey'}
                        href={'/' + category?.parent?.primaryRoute.id}
                     >
                        <NavArrowLeft></NavArrowLeft>
                        {removeAlternativeString(category?.parent?.name)}
                     </SiteButton>
                  )}
                  {hasSubCategories && (
                     <p className="page-hero-category-title my-16">
                        {t('Choose-category')}
                     </p>
                  )}
                  <div className="category-tags-inner-wrapper">
                     {/* <Below breakpoint="lg">
                        {category?.parent && (
                           <SiteButton
                              size="medium"
                              styleType="solid"
                              color={'blue'}
                              value={category?.parent?.name}
                              href={'/' + category?.parent?.primaryRoute.id}
                           ></SiteButton>
                        )}
                     </Below> */}
                     <div
                        className={`category-tags-container ${
                           fade ? 'hide-fade' : ''
                        }`}
                        onScroll={handleScroll}
                     >
                        {hasSubCategories && (
                           <SiteButton
                              className="px-32 py-8 override-button d-none d-md-block"
                              size="small"
                              styleType="solid"
                              color={'grey'}
                              value={removeAlternativeString(category?.name)}
                              disabled={true}
                           ></SiteButton>
                        )}

                        {sortedSubCategories.map(subcategory => {
                           return (
                              <SiteButton
                                 key={subcategory?.id}
                                 className="px-32 py-8 override-button"
                                 size="small"
                                 styleType="solid"
                                 color={'blue'}
                                 value={removeAlternativeString(subcategory.name)}
                                 href={'/' + subcategory?.primaryRoute.id}
                              ></SiteButton>
                           )
                        })}

                        {/* {sortedSubCategories?.length == 0 && category?.parent?.id != BRAND_PAGE_ID &&
                           sortedSiblingsCategories.map(subcategory => {
                              return (
                                 <SiteButton
                                    key={subcategory?.id}
                                    className="px-32 py-8 override-button"
                                    size="small"
                                    styleType="solid"
                                    color={'blue'}
                                    value={subcategory.name}
                                    href={'/' + subcategory?.primaryRoute.id}
                                 ></SiteButton>
                              )
                           })} */}
                     </div>
                  </div>
               </CategoryTagsWrapper>
            )}
      </>
   )
}

export default CategoryTags
